import { useEffect, useState } from 'react';

export const useLocalStorageState = <T>(key: string, defaultValue: T) => {
  const [state, setState] = useState<T>(() => {
    const stored = localStorage.getItem(key);
    if (!stored) return defaultValue;

    try {
      const parsed: unknown = JSON.parse(stored);

      // If both defaultValue and parsed are objects → merge
      if (
        typeof defaultValue === 'object' &&
        defaultValue !== null &&
        typeof parsed === 'object' &&
        parsed !== null &&
        !Array.isArray(defaultValue)
      ) {
        return {
          ...defaultValue, // merge defaults
          ...(parsed as Partial<T>), // override with stored values
        };
      }

      // Otherwise return parsed directly (primitive case)
      return parsed as T;
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState] as const;
};
